import { createContext } from 'react';

export interface EmbeddedAuthContextValue {
  registerEmbeddedFrame: (registration: {
    productId: string;
    productName: string;
    iframeWindow: Window;
    trustedOrigin: string;
    requestedScopes?: string[];
  }) => void;
  unregisterEmbeddedFrame: (productId: string) => void;
}

export const EmbeddedAuthContext = createContext<
  EmbeddedAuthContextValue | undefined
>(undefined);
